import { Navigate, Route, Routes } from "react-router-dom";

import { LoginPage } from "@/features/auth/LoginPage";
import { RegisterPage } from "@/features/auth/RegisterPage";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { AdminLoginPage } from "@/features/admin/AdminLoginPage";
import { AdminUsersPage } from "@/features/admin/AdminUsersPage";
import SelskapsinfoPage from "@/features/selskapsinfo/SelskapsinfoPage";
import { GroupRoomsPage } from "@/features/dashboard/GroupRoomsPage";
import { SettingsPage } from "@/features/settings/SettingsPage";
import { DevicesPage } from "@/features/devices/DevicesPage";
import { LoanStatusPage } from "@/features/loanstatus/LoanStatusPage";
import { PreviewAsLoanerPage } from "@/features/admin/PreviewAsLoanerPage";
import { ProtectedRoute } from "./ProtectedRoute";

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/preview" element={<PreviewAsLoanerPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute requireAdmin>
            <AdminUsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/selskapsinfo/:orgnr?"
        element={
          <ProtectedRoute requireAdmin>
            <SelskapsinfoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/grupperom"
        element={
          <ProtectedRoute>
            <GroupRoomsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/laanestatus"
        element={
          <ProtectedRoute>
            <LoanStatusPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/innstillinger"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enheter"
        element={
          <ProtectedRoute anyRole>
            <DevicesPage />
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
